module.exports = "../static/images/414db0.png";